export default "__VITE_ASSET__nEHSCzH$__"